import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MainLoadingService {

  constructor() { }
  private loading: boolean = false;

  mainLoading: Subject<any> = new Subject<any>();
  mainLoadingChanged$ = this.mainLoading.asObservable();
  progressBar: Subject<boolean> = new Subject<boolean>();
  progressBarChanged$ = this.progressBar.asObservable();

  setLoading(loading:boolean){
    this.loading = loading;
    this.mainLoading.next(this.loading);
  }

  getLoading(){
    return this.loading;
  }

  clearLoading(){
    this.loading = false;
  }

  setProgressBar(isProgressing: boolean){
    this.progressBar.next(isProgressing);
  }

  getProgressBar(){
    return this.progressBar;
  }
}
